import React from "react"
import types from "prop-types"
import clsx from "clsx"
import Popup from "reactjs-popup";
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { ensureDropdownVisible } from "utils/reactSelectHelpers"
import { CustomIconButton } from "shared/buttons"
import { Select } from "shared/selects"
import FacilityDepartmentDropdown from "./FacilityDepartmentDropdown"

const departmentsToOptions = (departments) => departments.map(({ name, id, ...rest }) => (
  {
    label: name,
    value: id,
    ...rest,
  }
))

const TaskDepartmentSelector = ({ className = "", departments, onChange }) => {
  const {
    pluralName: departmentsName,
    pluralNameInSentence: departmentsNameInSentence,
  } = useCustomName(DEPARTMENT_KEY)

  return (
    <div className={clsx("flex", className)}>
      <Popup
        trigger={
          (
            <CustomIconButton
              className="w-full md:w-auto border border-light text-sm justify-end"
              icon="add-department"
              text={`Add ${departmentsName}`}
            />
          )
        }
        position="bottom left"
      >
        <div className="h-0 invisible">
          <div className="w-96">
            <Select
              backspaceDelete={false}
              className="react-dropdown-select base-input component-border-thin rounded-md -top-11 -left-[1px]"
              dropdownGap={0}
              dropdownRenderer={FacilityDepartmentDropdown}
              keepOpen
              labelField="label"
              multi={false}
              onChange={onChange}
              onDropdownOpen={ensureDropdownVisible}
              options={departmentsToOptions(departments)}
              placeholder={`Add ${departmentsNameInSentence} by name ...`}
              searchable
              style={{ width: "24rem", maxWidth: "calc(100vw - 4rem + 2px)" }}
              // TODO: label not appearing in accessibility tree view. Because of dropdownRenderer?
              // label = "select departments"
            />
          </div>
        </div>
      </Popup>
    </div>
  )
}

TaskDepartmentSelector.propTypes = {
  className: types.string,
  departments: types.arrayOf(types.shape({
    id: types.number.isRequired,
    name: types.string.isRequired,
  })).isRequired,
  onChange: types.func.isRequired,
}

export default TaskDepartmentSelector
